import { AxiosBaseQueryFunction } from 'api/axiosBaseQuery';

import { CustomSideModel } from '@common/models/predefined-custom-side.model';
import { TypedUseQueryHookResult } from '@reduxjs/toolkit/dist/query/react';

import { useFetchCustomSidesQuery } from '../../../../../api/static-content-api/custom-sides.api/customSidesService';

type useCustomSidesReturn = Omit<
    TypedUseQueryHookResult<CustomSideModel[], void, AxiosBaseQueryFunction>,
    'data' | 'isFetching'
> & {
    areCustomSidesLoading: boolean;
    customSides?: CustomSideModel[];
};

const useCustomSides = (): useCustomSidesReturn => {
    const { data: customSides, isFetching: areCustomSidesLoading, ...rest } = useFetchCustomSidesQuery();

    return {
        areCustomSidesLoading,
        customSides,
        ...rest,
    };
};

export default useCustomSides;
